export const LANGUAGE_STORAGE_KEY = "touts_routes_language"

export const translations = {
  en: {
    common: {
      loading: "Loading...",
      search: "Search",
      view: "View",
      close: "Close",
      previous: "Previous",
      next: "Next",
      pageOf: "Page {page} of {total}",
      allStatuses: "All statuses",
      status: "Status",
      actions: "Actions",
      name: "Name",
      email: "Email",
      phone: "Phone",
      user: "User",
      captain: "Captain",
      date: "Date",
      notAvailable: "Not available",
      notSpecified: "Not specified",
      unassigned: "Unassigned",
      online: "Online",
      offline: "Offline",
      unknown: "Unknown",
      noPhoto: "No photo",
      openImage: "Open {label}",
      admin: "Admin",
      egp: "EGP",
      kilometres: "km",
      language: "Language",
      switchToArabic: "Switch to Arabic",
      switchToEnglish: "Switch to English",
      arabic: "العربية",
      english: "English"
    },
    auth: {
      adminDashboard: "Admin Dashboard",
      systemOnline: "System online",
      emailAddress: "Email address",
      password: "Password",
      signIn: "Sign in",
      signingIn: "Signing in...",
      helpQuestion: "Need help accessing your account?",
      contactSupport: "Contact support",
      privacyPolicy: "Privacy policy",
      rightsReserved: "© {year} Tout's Routes. All rights reserved.",
      loginFailed: "Login failed. Please check your credentials.",
      connectionError: "Connection error. Please try again."
    },
    nav: {
      dashboard: "Dashboard",
      captains: "Captains",
      captainControls: "Captain Controls",
      users: "Users",
      bookings: "Bookings",
      financials: "Financials",
      notifications: "Notifications",
      receipts: "Receipt Delivery",
      operationalControl: "Operational Control",
      exceptions: "Booking Exceptions",
      auditLog: "Admin Activity Log",
      captainPricing: "Captain Pricing",
      liveMap: "Live map",
      logout: "Log out",
      welcomeBack: "Welcome back, {name}",
      expandSidebar: "Expand navigation",
      collapseSidebar: "Collapse navigation",
      openMenu: "Open navigation menu",
      closeMenu: "Close navigation menu",
      settings: "Settings"
    },
    dashboard: {
      totalUsers: "Total users",
      newToday: "+{count} today",
      totalCaptains: "Total captains",
      pendingCount: "{count} pending",
      openedBookings: "Open bookings",
      todayCount: "{count} today",
      todayRevenue: "Today's revenue",
      commissionValue: "Commission: {value}",
      bookingsTrend: "Bookings trend (7 days)",
      revenueTrend: "Revenue trend (7 days)",
      bookings: "Bookings",
      revenue: "Revenue",
      commission: "Commission",
      recentActivity: "Recent activity",
      noRecentActivity: "No recent activity",
      serviceAreaAvailability: "Online captains by declared service area",
      serviceAreaAvailabilityHint: "Based on the governorate selected during captain registration; this is not live GPS location.",
      onlineOfTotal: "{total} registered captains in this area",
      unassignedArea: "No service area selected",
      noAreaData: "No declared service-area data available",
      systemHealthTitle: "System health",
      systemHealthHint: "A lightweight check of the control panel services.",
      systemHealthApi: "API and database",
      systemHealthOperations: "Operations service",
      systemHealthLiveMap: "Live Map service",
      systemHealthChecking: "Checking",
      systemHealthHealthy: "Healthy",
      systemHealthDown: "Unavailable",
      systemHealthUpdated: "Checked {time}",
      dailyReportTitle: "Daily operations report",
      dailyReportHint: "Today’s activity and exceptions requiring attention.",
      dailyActiveTrips: "Active trips",
      dailyUnassigned: "Unassigned bookings",
      dailyOnlineCaptains: "Online captains",
      dailyCompleted: "Completed today",
      dailyCancelled: "Cancelled today",
      dailyPendingCaptains: "Pending captains",
      dailyExceptions: "Exceptions",
      exceptionStaleCaptain: "Stale captain heartbeat",
      exceptionUnassigned: "Booking has no assigned captain",
      exceptionStuck: "Booking may be stuck",
      noExceptions: "No exceptions requiring attention"
    },
    operations: {
      title: "Operational Control",
      subtitle: "Monitor active trips, captain availability, and operational alerts in real time.",
      refresh: "Refresh",
      activeTrips: "Active trips",
      unassignedBookings: "Unassigned bookings",
      onlineCaptains: "Online captains",
      staleCaptains: "Stale captain heartbeats",
      pendingCaptains: "Pending captains",
      completedToday: "Completed today",
      cancelledToday: "Cancelled today",
      alerts: "Operational alerts",
      alertsHint: "Items that may need administrator attention.",
      staleCaptain: "Captain heartbeat is stale",
      unassignedBooking: "Booking has no assigned captain",
      stuckBooking: "Booking may be stuck",
      minutes: "minutes",
      noAlerts: "No operational alerts"
    },
    notifications: {
      title: "Send notification",
      subtitle: "Send a Firebase push notification to selected captains, users, or everyone.",
      recipientType: "Recipients",
      captains: "Captains",
      users: "Users",
      all: "Everyone",
      chooseRecipients: "Choose recipients",
      selectAll: "Select all",
      clear: "Clear",
      noRecipients: "No recipients found",
      titleField: "Notification title",
      messageField: "Message",
      titlePlaceholder: "For example: Important service update",
      messagePlaceholder: "Write the message to send...",
      send: "Send notification",
      sending: "Sending...",
      confirmAll: "This will send the notification to every account with a device token. Continue?",
      sharedTokenWarning: "Warning: this account shares a device token with another account on the same device, so that device may show the notification to both logged-in accounts.",
      sentResult: "Matched {matched_recipients}, found {devices_with_tokens} device token(s), sent {sent}, failed {failed}.",
      historyTitle: "Notification delivery history",
      historyHint: "Review individual send results and retry failed device deliveries.",
      refreshHistory: "Refresh history",
      noHistory: "No notifications have been sent yet.",
      sentAt: "Sent at",
      messageSummary: "Message",
      recipients: "Recipients",
      deliveryStatus: "Delivery status",
      sentCount: "Sent: {count}",
      failedCount: "Failed: {count}",
      skippedCount: "Skipped: {count}",
      retryFailed: "Retry failed",
      retrying: "Retrying..."
    },
    receipts: {
      title: "Receipt Delivery",
      subtitle: "Track receipts generated after completed trips and retry failed deliveries.",
      refresh: "Refresh",
      empty: "No completed trips found.",
      booking: "Booking",
      passenger: "Passenger",
      completed: "Completed",
      fare: "Fare",
      status: "Receipt status",
      lastAttempt: "Last attempt",
      action: "Action",
      noEmail: "No email address",
      attempts: "Attempts: {count}",
      retry: "Retry receipt",
      retrying: "Queuing...",
      statuses: { sent: "Sent", queued: "Queued", failed: "Failed", not_tracked: "Not tracked" }
    },
    exceptions: {
      title: "Booking Exception Center",
      subtitle: "Find trips and receipts that may require administrator attention.",
      refresh: "Refresh",
      updated: "Updated {time}",
      critical: "Critical",
      warning: "Warnings",
      information: "Information",
      total: "Total exceptions",
      listTitle: "Exceptions requiring attention",
      listHint: "The list refreshes automatically without refreshing the page.",
      noExceptions: "No exceptions require attention right now.",
      loadFailed: "Could not load booking exceptions.",
      unknownPassenger: "Unknown passenger",
      unassignedCaptain: "No captain assigned",
      minutesAgo: "minutes old",
      openBooking: "Open booking",
      severities: { critical: "Critical", warning: "Warning", information: "Information" },
      types: {
        unassigned_booking: "Unassigned booking",
        acceptance_timeout: "Captain acceptance timeout",
        active_trip_no_gps: "Active trip without recent GPS",
        stale_active_trip: "Stale active trip",
        receipt_failed: "Receipt delivery failed",
        receipt_queued: "Receipt still queued",
        receipt_not_tracked: "Receipt not tracked",
        repeated_cancellations: "Repeated cancellations"
      }
    },
    audit: {
      title: "Admin Activity Log",
      subtitle: "Review important actions performed in the control panel.",
      refresh: "Refresh",
      filter: "Filter actions",
      allActions: "All actions",
      empty: "No administrator activity has been recorded yet.",
      loadFailed: "Could not load the activity log.",
      time: "Time",
      administrator: "Administrator",
      action: "Action",
      resource: "Resource",
      details: "Details",
      ip: "IP address",
      actions: {
        admin_login: "Admin login",
        user_status_changed: "User status changed",
        user_governorate_changed: "User governorate changed",
        captain_status_changed: "Captain status changed",
        captain_approved: "Captain approved",
        captain_rejected: "Captain rejected",
        captain_activated: "Captain activated",
        captain_deactivated: "Captain deactivated",
        notification_sent: "Notification sent",
        notification_retry: "Notification retry",
        receipt_retry: "Receipt retry"
      }
    },
    pricing: {
      title: "Captain Pricing Monitor",
      subtitle: "See the current prices set by every online captain and track changes.",
      refresh: "Refresh",
      online: "Online",
      onlineCaptains: "Online captains",
      autoRefresh: "Updates automatically every 15 seconds",
      noOnline: "No active online captains found.",
      noGovernorate: "No governorate selected",
      service: "Service",
      perKm: "Rate/km",
      minimum: "Minimum fare",
      waiting: "Waiting rate",
      hourly: "Hourly rate",
      heartbeat: "Last heartbeat",
      historyTitle: "Rate-change history",
      historyHint: "Every captain rate update is recorded with the old and new values.",
      noChanges: "No captain rate changes have been recorded yet.",
      changedRates: "Captain rates changed",
      loadFailed: "Could not load captain pricing."
    },
    users: {
      title: "User management",
      searchPlaceholder: "Search by name, email, or phone...",
      registrationLocation: "Registration location (approx.)",
      userPhoto: "User photo",
      governorate: "Governorate",
      bookings: "Bookings",
      totalSpent: "Total spent",
      noUsers: "No users found",
      profilePicture: "Profile picture",
      approximateRegistrationLocation: "Approximate registration location",
      totalBookings: "Total bookings",
      changeStatus: "Change status",
      activate: "Activate",
      deactivate: "Deactivate",
      block: "Block",
      profilePhotoAlt: "{name} profile photo"
    },
    captains: {
      title: "Captain management",
      searchPlaceholder: "Search by name, email, or phone...",
      registrationLocation: "Registration location (approx.)",
      profilePhoto: "Profile photo",
      vehiclePhoto: "Vehicle photo",
      vehicle: "Vehicle",
      rating: "Rating",
      presence: "Online status",
      reliability: "GPS reliability",
      reliabilityTitle: "Presence reliability",
      reliabilityHint: "Shows whether an online captain has a current, stale, or missing GPS location.",
      reliabilityWindow: "Live GPS threshold: 90 seconds",
      gps_live: "GPS live",
      gps_stale: "GPS stale",
      online_no_gps: "Online without GPS",
      allPresence: "All presence",
      online: "Online",
      offline: "Offline",
      unknown: "Unknown",
      lastSeen: "Last seen",
      heartbeat: "Heartbeat",
      refreshStatus: "Refresh status",
      lastUpdated: "Updated {time}",
      statusUpdating: "Updating captain status...",
      noCaptains: "No captains found",
      approximateRegistrationLocation: "Approximate registration location",
      profilePicture: "Profile picture",
      approve: "Approve",
      reject: "Reject",
      activate: "Activate",
      deactivate: "Deactivate",
      delete: "Delete",
      profilePhotoAlt: "{name} profile photo",
      vehiclePhotoAlt: "{name} vehicle photo",
      confirmApprove: "Approve and activate {name}?",
      confirmReject: "Reject {name}?",
      confirmDeactivate: "Deactivate {name}?",
      confirmDelete: "Permanently delete {name}? This cannot be undone.",
      profileControls: "Captain profile correction",
      editSettings: "Edit settings",
      governorate: "Governorate",
      vehicleType: "Vehicle type",
      service: "Service",
      ratePerKm: "Rate per km",
      minimumFare: "Minimum fare",
      waitingRate: "Waiting rate",
      hourlyRate: "Hourly rate",
      saveSettings: "Save profile corrections",
      savingSettings: "Saving...",
      settingsSaved: "Captain settings updated successfully.",
      settingsLoadFailed: "Could not load the captain settings.",
      settingsSaveFailed: "Could not save the captain settings."
    },
    bookings: {
      title: "Booking management",
      bookingId: "Booking ID",
      service: "Service",
      fare: "Fare",
      noBookings: "No bookings found",
      bookingNumber: "Booking #{id}",
      serviceType: "Service type",
      route: "Route",
      from: "From",
      to: "To",
      distance: "Distance",
      pricing: "Pricing",
      estimatedFare: "Estimated fare",
      finalFare: "Final fare",
      appCommission: "App commission",
      captainEarning: "Captain earning"
    },
    financials: {
      title: "Financial management",
      totalRevenue: "Total revenue",
      thisPeriod: "This period",
      appCommission: "App commission",
      percentOfRevenue: "{value}% of revenue",
      captainEarnings: "Captain earnings",
      distributedToCaptains: "Distributed to captains",
      paymentMethods: "Payment methods",
      cash: "Cash",
      instapay: "InstaPay",
      dailyRevenue: "Daily revenue (last 30 days)",
      revenue: "Revenue",
      commission: "Commission",
      recentTransactions: "Recent commission transactions",
      bookingId: "Booking ID",
      finalFare: "Final fare",
      captainEarning: "Captain earning",
      noCommissionData: "No commission data available",
      exportData: "Export financial data",
      exportTransactions: "Export transactions",
      exportCommissions: "Export commissions",
      exportRevenue: "Export revenue report"
    },
    privacy: {
      backToSignIn: "Back to sign in",
      title: "Privacy policy",
      effectiveDate: "Effective date: August 16, 2026",
      intro: "This Privacy Policy explains how Tout's Routes collects, uses, shares, and protects information when you use our mobile application, website, and related services.",
      signIn: "Tout's Routes sign in",
      contactSupport: "Contact support"
    },
    status: {
      active: "Active",
      pending: "Pending",
      deactivated: "Deactivated",
      blocked: "Blocked",
      rejected: "Rejected",
      accepted: "Accepted",
      enroute: "En route",
      arrived: "Arrived",
      completed: "Completed",
      cancelled: "Cancelled",
      disputed: "Disputed"
    },
    service: {
      economy: "Economy",
      family: "Family",
      medical: "Medical",
      luxury: "Luxury",
      schooltrips: "School trips",
      scooter: "Scooter"
    },
    vehicle: {
      car: "Car",
      sedan: "Sedan",
      suv: "SUV",
      van: "Van",
      scooter: "Scooter",
      motorcycle: "Motorcycle",
      motorbike: "Motorbike",
      withVehicle: "With vehicle",
      withoutVehicle: "Without vehicle",
      noVehicle: "No vehicle"
    },
    governorate: {
      cairo: "Cairo",
      giza: "Giza",
      asyut: "Asyut",
      redsea: "Red Sea",
      southsinai: "South Sinai",
      alexandria: "Alexandria"
    },
    errors: {
      generic: "Something went wrong. Please try again.",
      sessionExpired: "Your administrator session has expired. Please sign in again.",
      fetchUsers: "Failed to load users.",
      updateUserStatus: "Failed to update the user status.",
      updateGovernorate: "Failed to update the governorate.",
      fetchCaptains: "Failed to load captains.",
      fetchRecipients: "Failed to load notification recipients.",
      sendNotification: "Failed to send notification.",
      fetchBookings: "Failed to load bookings.",
      fetchFinancials: "Failed to load financial data."
    }
  },
  ar: {
    common: {
      loading: "جارٍ التحميل...",
      search: "بحث",
      view: "عرض",
      close: "إغلاق",
      previous: "السابق",
      next: "التالي",
      pageOf: "الصفحة {page} من {total}",
      allStatuses: "كل الحالات",
      status: "الحالة",
      actions: "الإجراءات",
      name: "الاسم",
      email: "البريد الإلكتروني",
      phone: "رقم الهاتف",
      user: "المستخدم",
      captain: "الكابتن",
      date: "التاريخ",
      notAvailable: "غير متاح",
      notSpecified: "غير محدد",
      unassigned: "غير معيّن",
      online: "متصل",
      offline: "غير متصل",
      unknown: "غير معروف",
      noPhoto: "لا توجد صورة",
      openImage: "فتح {label}",
      admin: "المشرف",
      egp: "ج.م",
      kilometres: "كم",
      language: "اللغة",
      switchToArabic: "التبديل إلى العربية",
      switchToEnglish: "التبديل إلى الإنجليزية",
      arabic: "العربية",
      english: "English"
    },
    auth: {
      adminDashboard: "لوحة تحكم الإدارة",
      systemOnline: "النظام متصل",
      emailAddress: "البريد الإلكتروني",
      password: "كلمة المرور",
      signIn: "تسجيل الدخول",
      signingIn: "جارٍ تسجيل الدخول...",
      helpQuestion: "هل تحتاج إلى مساعدة في الدخول إلى حسابك؟",
      contactSupport: "تواصل مع الدعم",
      privacyPolicy: "سياسة الخصوصية",
      rightsReserved: "© {year} Tout's Routes. جميع الحقوق محفوظة.",
      loginFailed: "فشل تسجيل الدخول. يرجى التحقق من بيانات الدخول.",
      connectionError: "تعذر الاتصال بالخادم. يرجى المحاولة مرة أخرى."
    },
    nav: {
      dashboard: "لوحة المعلومات",
      captains: "الكباتن",
      captainControls: "تحكم الكباتن",
      users: "المستخدمون",
      bookings: "الحجوزات",
      financials: "الإدارة المالية",
      notifications: "الإشعارات",
      receipts: "تسليم الإيصالات",
      operationalControl: "التحكم التشغيلي",
      exceptions: "استثناءات الحجوزات",
      auditLog: "سجل نشاط المشرفين",
      captainPricing: "أسعار الكباتن",
      liveMap: "الخريطة المباشرة",
      logout: "تسجيل الخروج",
      welcomeBack: "مرحباً بعودتك، {name}",
      expandSidebar: "توسيع قائمة التنقل",
      collapseSidebar: "طي قائمة التنقل",
      openMenu: "فتح قائمة التنقل",
      closeMenu: "إغلاق قائمة التنقل",
      settings: "الإعدادات"
    },
    dashboard: {
      totalUsers: "إجمالي المستخدمين",
      newToday: "+{count} اليوم",
      totalCaptains: "إجمالي الكباتن",
      pendingCount: "{count} قيد المراجعة",
      openedBookings: "الحجوزات المفتوحة",
      todayCount: "{count} اليوم",
      todayRevenue: "إيرادات اليوم",
      commissionValue: "العمولة: {value}",
      bookingsTrend: "اتجاه الحجوزات خلال 7 أيام",
      revenueTrend: "اتجاه الإيرادات خلال 7 أيام",
      bookings: "الحجوزات",
      revenue: "الإيرادات",
      commission: "العمولة",
      recentActivity: "أحدث الأنشطة",
      noRecentActivity: "لا توجد أنشطة حديثة",
      serviceAreaAvailability: "الكباتن المتصلون حسب منطقة الخدمة المعلنة",
      serviceAreaAvailabilityHint: "تعتمد على المحافظة التي اختارها الكابتن أثناء التسجيل، وليست موقع GPS مباشرًا.",
      onlineOfTotal: "{total} كابتن مسجل في هذه المنطقة",
      unassignedArea: "لم يتم تحديد منطقة خدمة",
      noAreaData: "لا تتوفر بيانات عن مناطق الخدمة المعلنة",
      systemHealthTitle: "حالة النظام",
      systemHealthHint: "فحص خفيف لخدمات لوحة التحكم.",
      systemHealthApi: "واجهة API وقاعدة البيانات",
      systemHealthOperations: "خدمة العمليات",
      systemHealthLiveMap: "خدمة الخريطة المباشرة",
      systemHealthChecking: "جارٍ الفحص",
      systemHealthHealthy: "تعمل بشكل جيد",
      systemHealthDown: "غير متاحة",
      systemHealthUpdated: "آخر فحص {time}",
      dailyReportTitle: "تقرير العمليات اليومي",
      dailyReportHint: "نشاط اليوم والاستثناءات التي تحتاج إلى اهتمام.",
      dailyActiveTrips: "الرحلات النشطة",
      dailyUnassigned: "الحجوزات غير المعيّنة",
      dailyOnlineCaptains: "الكباتن المتصلون",
      dailyCompleted: "المكتملة اليوم",
      dailyCancelled: "الملغاة اليوم",
      dailyPendingCaptains: "الكباتن قيد المراجعة",
      dailyExceptions: "الاستثناءات",
      exceptionStaleCaptain: "نبض الكابتن متأخر",
      exceptionUnassigned: "حجز بدون كابتن معيّن",
      exceptionStuck: "قد يكون الحجز متعطلاً",
      noExceptions: "لا توجد استثناءات تحتاج إلى اهتمام"
    },
    operations: {
      title: "التحكم التشغيلي",
      subtitle: "راقب الرحلات النشطة وتوفر الكباتن والتنبيهات التشغيلية لحظياً.",
      refresh: "تحديث",
      activeTrips: "الرحلات النشطة",
      unassignedBookings: "الحجوزات غير المعينة",
      onlineCaptains: "الكباتن المتصلون",
      staleCaptains: "نبضات كباتن قديمة",
      pendingCaptains: "الكباتن قيد المراجعة",
      completedToday: "المكتملة اليوم",
      cancelledToday: "الملغاة اليوم",
      alerts: "التنبيهات التشغيلية",
      alertsHint: "عناصر قد تحتاج إلى متابعة من الإدارة.",
      staleCaptain: "نبضة اتصال الكابتن قديمة",
      unassignedBooking: "الحجز ليس له كابتن معين",
      stuckBooking: "قد يكون الحجز متعثراً",
      minutes: "دقائق",
      noAlerts: "لا توجد تنبيهات تشغيلية"
    },
    notifications: {
      title: "إرسال إشعار",
      subtitle: "إرسال إشعار Firebase للكباتن أو المستخدمين المحددين أو للجميع.",
      recipientType: "المستلمون",
      captains: "الكباتن",
      users: "المستخدمون",
      all: "الجميع",
      chooseRecipients: "اختر المستلمين",
      selectAll: "تحديد الكل",
      clear: "مسح التحديد",
      noRecipients: "لا يوجد مستلمون",
      titleField: "عنوان الإشعار",
      messageField: "الرسالة",
      titlePlaceholder: "مثال: تحديث مهم للخدمة",
      messagePlaceholder: "اكتب الرسالة المراد إرسالها...",
      send: "إرسال الإشعار",
      sending: "جارٍ الإرسال...",
      confirmAll: "سيتم إرسال الإشعار إلى كل الحسابات التي لديها رمز جهاز. هل تريد المتابعة؟",
      sharedTokenWarning: "تحذير: هذا الحساب يستخدم رمز جهاز مشتركًا مع حساب آخر على نفس الجهاز، لذلك قد يظهر الإشعار للحسابين المسجلين على الجهاز.",
      sentResult: "تم العثور على {matched_recipients}، وبها {devices_with_tokens} رمز جهاز، وتم الإرسال إلى {sent} وفشل {failed}.",
      historyTitle: "سجل تسليم الإشعارات",
      historyHint: "راجع نتائج الإرسال وأعد محاولة التسليمات الفاشلة.",
      refreshHistory: "تحديث السجل",
      noHistory: "لم يتم إرسال أي إشعارات بعد.",
      sentAt: "وقت الإرسال",
      messageSummary: "الرسالة",
      recipients: "المستلمون",
      deliveryStatus: "حالة التسليم",
      sentCount: "تم الإرسال: {count}",
      failedCount: "فشل: {count}",
      skippedCount: "تم التخطي: {count}",
      retryFailed: "إعادة محاولة الفاشل",
      retrying: "جارٍ إعادة المحاولة..."
    },
    receipts: {
      title: "تسليم الإيصالات",
      subtitle: "تتبع الإيصالات بعد اكتمال الرحلات وأعد محاولة التسليمات الفاشلة.",
      refresh: "تحديث",
      empty: "لا توجد رحلات مكتملة.",
      booking: "الحجز",
      passenger: "الراكب",
      completed: "وقت الإكمال",
      fare: "الأجرة",
      status: "حالة الإيصال",
      lastAttempt: "آخر محاولة",
      action: "الإجراء",
      noEmail: "لا يوجد بريد إلكتروني",
      attempts: "المحاولات: {count}",
      retry: "إعادة إرسال الإيصال",
      retrying: "جارٍ التجهيز...",
      statuses: { sent: "تم الإرسال", queued: "قيد الانتظار", failed: "فشل", not_tracked: "غير متتبع" }
    },
    exceptions: {
      title: "مركز استثناءات الحجوزات",
      subtitle: "اعثر على الرحلات والإيصالات التي قد تحتاج إلى متابعة الإدارة.",
      refresh: "تحديث",
      updated: "آخر تحديث {time}",
      critical: "حرج",
      warning: "تحذيرات",
      information: "معلومات",
      total: "إجمالي الاستثناءات",
      listTitle: "استثناءات تحتاج إلى متابعة",
      listHint: "يتم تحديث القائمة تلقائياً دون إعادة تحميل الصفحة.",
      noExceptions: "لا توجد استثناءات تحتاج إلى متابعة حالياً.",
      loadFailed: "تعذر تحميل استثناءات الحجوزات.",
      unknownPassenger: "راكب غير معروف",
      unassignedCaptain: "لم يتم تعيين كابتن",
      minutesAgo: "دقيقة مضت",
      openBooking: "فتح الحجز",
      severities: { critical: "حرج", warning: "تحذير", information: "معلومات" },
      types: {
        unassigned_booking: "حجز غير معيّن",
        acceptance_timeout: "تأخر بدء الرحلة بعد القبول",
        active_trip_no_gps: "رحلة نشطة بدون GPS حديث",
        stale_active_trip: "رحلة نشطة متأخرة",
        receipt_failed: "فشل تسليم الإيصال",
        receipt_queued: "الإيصال ما زال قيد الانتظار",
        receipt_not_tracked: "الإيصال غير متتبع",
        repeated_cancellations: "إلغاءات متكررة"
      }
    },
    audit: {
      title: "سجل نشاط المشرفين",
      subtitle: "راجع الإجراءات المهمة التي تمت داخل لوحة التحكم.",
      refresh: "تحديث",
      filter: "تصفية الإجراءات",
      allActions: "كل الإجراءات",
      empty: "لم يتم تسجيل أي نشاط للمشرفين بعد.",
      loadFailed: "تعذر تحميل سجل النشاط.",
      time: "الوقت",
      administrator: "المشرف",
      action: "الإجراء",
      resource: "السجل المتأثر",
      details: "التفاصيل",
      ip: "عنوان IP",
      actions: {
        admin_login: "تسجيل دخول المشرف",
        user_status_changed: "تغيير حالة المستخدم",
        user_governorate_changed: "تغيير محافظة المستخدم",
        captain_status_changed: "تغيير حالة الكابتن",
        captain_approved: "الموافقة على الكابتن",
        captain_rejected: "رفض الكابتن",
        captain_activated: "تفعيل الكابتن",
        captain_deactivated: "إلغاء تفعيل الكابتن",
        notification_sent: "إرسال إشعار",
        notification_retry: "إعادة محاولة إشعار",
        receipt_retry: "إعادة محاولة إيصال"
      }
    },
    pricing: {
      title: "مراقبة أسعار الكباتن",
      subtitle: "اعرض الأسعار الحالية لكل كابتن متصل وتابع أي تغييرات.",
      refresh: "تحديث",
      online: "متصل",
      onlineCaptains: "الكباتن المتصلون",
      autoRefresh: "يتم التحديث تلقائياً كل 15 ثانية",
      noOnline: "لا يوجد كباتن نشطون متصلون حالياً.",
      noGovernorate: "لم يتم اختيار محافظة",
      service: "الخدمة",
      perKm: "السعر/كم",
      minimum: "الحد الأدنى للأجرة",
      waiting: "سعر الانتظار",
      hourly: "السعر بالساعة",
      heartbeat: "آخر نبضة اتصال",
      historyTitle: "سجل تغييرات الأسعار",
      historyHint: "يتم تسجيل كل تحديث لأسعار الكابتن مع القيم القديمة والجديدة.",
      noChanges: "لم يتم تسجيل أي تغييرات في أسعار الكباتن بعد.",
      changedRates: "تم تغيير أسعار الكابتن",
      loadFailed: "تعذر تحميل أسعار الكباتن."
    },
    users: {
      title: "إدارة المستخدمين",
      searchPlaceholder: "ابحث بالاسم أو البريد الإلكتروني أو رقم الهاتف...",
      registrationLocation: "موقع التسجيل (تقريبي)",
      userPhoto: "صورة المستخدم",
      governorate: "المحافظة",
      bookings: "الحجوزات",
      totalSpent: "إجمالي الإنفاق",
      noUsers: "لا يوجد مستخدمون",
      profilePicture: "الصورة الشخصية",
      approximateRegistrationLocation: "موقع التسجيل التقريبي",
      totalBookings: "إجمالي الحجوزات",
      changeStatus: "تغيير الحالة",
      activate: "تفعيل",
      deactivate: "إلغاء التفعيل",
      block: "حظر",
      profilePhotoAlt: "الصورة الشخصية لـ{name}"
    },
    captains: {
      title: "إدارة الكباتن",
      searchPlaceholder: "ابحث بالاسم أو البريد الإلكتروني أو رقم الهاتف...",
      registrationLocation: "موقع التسجيل (تقريبي)",
      profilePhoto: "الصورة الشخصية",
      vehiclePhoto: "صورة المركبة",
      vehicle: "المركبة",
      rating: "التقييم",
      presence: "حالة الاتصال",
      reliability: "موثوقية GPS",
      reliabilityTitle: "موثوقية الحضور والموقع",
      reliabilityHint: "يوضح ما إذا كان الكابتن المتصل لديه موقع حديث أو قديم أو غير متاح.",
      reliabilityWindow: "حد الموقع المباشر: 90 ثانية",
      gps_live: "GPS مباشر",
      gps_stale: "GPS قديم",
      online_no_gps: "متصل بدون GPS",
      allPresence: "كل حالات الاتصال",
      online: "متصل",
      offline: "غير متصل",
      unknown: "غير معروف",
      lastSeen: "آخر ظهور",
      heartbeat: "نبض الاتصال",
      refreshStatus: "تحديث الحالة",
      lastUpdated: "تم التحديث {time}",
      statusUpdating: "جارٍ تحديث حالة الكباتن...",
      noCaptains: "لا يوجد كباتن",
      approximateRegistrationLocation: "موقع التسجيل التقريبي",
      profilePicture: "الصورة الشخصية",
      approve: "موافقة",
      reject: "رفض",
      activate: "تفعيل",
      deactivate: "إلغاء التفعيل",
      delete: "حذف",
      profilePhotoAlt: "الصورة الشخصية لـ{name}",
      vehiclePhotoAlt: "صورة مركبة {name}",
      confirmApprove: "هل تريد الموافقة على {name} وتفعيل الحساب؟",
      confirmReject: "هل تريد رفض {name}؟",
      confirmDeactivate: "هل تريد إلغاء تفعيل {name}؟",
      confirmDelete: "هل تريد حذف {name} نهائياً؟ لا يمكن التراجع عن هذا الإجراء.",
      profileControls: "تصحيح بيانات الكابتن",
      editSettings: "تعديل الإعدادات",
      governorate: "المحافظة",
      vehicleType: "نوع المركبة",
      service: "الخدمة",
      ratePerKm: "السعر لكل كم",
      minimumFare: "الحد الأدنى للأجرة",
      waitingRate: "سعر الانتظار",
      hourlyRate: "السعر بالساعة",
      saveSettings: "حفظ تصحيحات الملف",
      savingSettings: "جارٍ الحفظ...",
      settingsSaved: "تم تحديث إعدادات الكابتن بنجاح.",
      settingsLoadFailed: "تعذر تحميل إعدادات الكابتن.",
      settingsSaveFailed: "تعذر حفظ إعدادات الكابتن."
    },
    bookings: {
      title: "إدارة الحجوزات",
      bookingId: "رقم الحجز",
      service: "الخدمة",
      fare: "الأجرة",
      noBookings: "لا توجد حجوزات",
      bookingNumber: "الحجز رقم {id}",
      serviceType: "نوع الخدمة",
      route: "المسار",
      from: "من",
      to: "إلى",
      distance: "المسافة",
      pricing: "التسعير",
      estimatedFare: "الأجرة التقديرية",
      finalFare: "الأجرة النهائية",
      appCommission: "عمولة التطبيق",
      captainEarning: "ربح الكابتن"
    },
    financials: {
      title: "الإدارة المالية",
      totalRevenue: "إجمالي الإيرادات",
      thisPeriod: "خلال هذه الفترة",
      appCommission: "عمولة التطبيق",
      percentOfRevenue: "{value}% من الإيرادات",
      captainEarnings: "أرباح الكباتن",
      distributedToCaptains: "تم توزيعها على الكباتن",
      paymentMethods: "طرق الدفع",
      cash: "نقداً",
      instapay: "إنستا باي",
      dailyRevenue: "الإيرادات اليومية خلال آخر 30 يوماً",
      revenue: "الإيرادات",
      commission: "العمولة",
      recentTransactions: "أحدث معاملات العمولات",
      bookingId: "رقم الحجز",
      finalFare: "الأجرة النهائية",
      captainEarning: "ربح الكابتن",
      noCommissionData: "لا توجد بيانات عمولات",
      exportData: "تصدير البيانات المالية",
      exportTransactions: "تصدير المعاملات",
      exportCommissions: "تصدير العمولات",
      exportRevenue: "تصدير تقرير الإيرادات"
    },
    privacy: {
      backToSignIn: "العودة إلى تسجيل الدخول",
      title: "سياسة الخصوصية",
      effectiveDate: "تاريخ السريان: 16 أغسطس 2026",
      intro: "توضح سياسة الخصوصية هذه كيفية جمع Tout's Routes للمعلومات واستخدامها ومشاركتها وحمايتها عند استخدام تطبيقنا وموقعنا والخدمات المرتبطة بهما.",
      signIn: "تسجيل الدخول إلى Tout's Routes",
      contactSupport: "التواصل مع الدعم"
    },
    status: {
      active: "نشط",
      pending: "قيد المراجعة",
      deactivated: "غير مفعّل",
      blocked: "محظور",
      rejected: "مرفوض",
      accepted: "مقبول",
      enroute: "في الطريق",
      arrived: "وصل",
      completed: "مكتمل",
      cancelled: "ملغي",
      disputed: "محل نزاع"
    },
    service: {
      economy: "على قد الإيد",
      family: "العائلية",
      medical: "الخدمات الطبية",
      luxury: "الفاخرة",
      schooltrips: "توصيل المدارس",
      scooter: "سكوتر"
    },
    vehicle: {
      car: "سيارة",
      sedan: "سيارة سيدان",
      suv: "سيارة دفع رباعي",
      van: "سيارة فان",
      scooter: "سكوتر",
      motorcycle: "دراجة نارية",
      motorbike: "دراجة نارية",
      withVehicle: "بمركبة",
      withoutVehicle: "بدون مركبة",
      noVehicle: "لا توجد مركبة"
    },
    governorate: {
      cairo: "القاهرة",
      giza: "الجيزة",
      asyut: "أسيوط",
      redsea: "البحر الأحمر",
      southsinai: "جنوب سيناء",
      alexandria: "الإسكندرية"
    },
    errors: {
      generic: "حدث خطأ. يرجى المحاولة مرة أخرى.",
      sessionExpired: "انتهت جلسة المشرف. يرجى تسجيل الدخول مرة أخرى.",
      fetchUsers: "تعذر تحميل المستخدمين.",
      updateUserStatus: "تعذر تحديث حالة المستخدم.",
      updateGovernorate: "تعذر تحديث المحافظة.",
      fetchCaptains: "تعذر تحميل الكباتن.",
      fetchRecipients: "تعذر تحميل مستلمي الإشعار.",
      sendNotification: "تعذر إرسال الإشعار.",
      fetchBookings: "تعذر تحميل الحجوزات.",
      fetchFinancials: "تعذر تحميل البيانات المالية."
    }
  }
}

export function normalizeLanguage(value) {
  return String(value || "").toLowerCase().startsWith("ar") ? "ar" : "en"
}

export function getTranslation(language, key) {
  const selected = translations[normalizeLanguage(language)]
  return key.split(".").reduce((current, segment) => current?.[segment], selected)
}

export function interpolate(template, params = {}) {
  return String(template).replace(/\{(\w+)\}/g, (_, key) =>
    params[key] === undefined || params[key] === null ? `{${key}}` : String(params[key])
  )
}

export function normalizeLookupKey(value) {
  return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, "")
}
